import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { Helmet } from "react-helmet";
import { useTheme } from "../../contexts/ThemeContext";
import FundAllocation from "./FundAllocatorDetails/FundAllocation";

const FundAllocator = () => {
  const { currentTheme } = useTheme();

  return (  
    <>
      <Helmet>
        <title>Fund Allocator | Vantage Alpha</title>
      </Helmet>

      <Box
        sx={{
          backgroundColor: currentTheme.palette.mode === 'light' 
            ? '#ebebeb'
            : currentTheme.palette.grey[50],
          background: currentTheme.palette.mode === 'light' 
            ? '#ebebeb'
            : currentTheme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: currentTheme.palette.text.primary,
                mb: 1,
              }}
            >
              Fund Allocator
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: currentTheme.palette.text.secondary,
              }}
            >
              View and edit fund allocations across strategies
            </Typography>
          </Box>
          <FundAllocation />
        </Container>
      </Box>
    </>
  );
};

export default FundAllocator; 